import React, { useContext, useEffect, useState } from "react";
import TildeOkAbonado from "../../../assets/images/generico/TildeOkAbonado";
import TurnoCanceladoIcon from "../../../assets/images/generico/TurnoCanceladoIcon";
import TurnoNoAsistidoIcon from "../../../assets/images/generico/TurnoNoAsistidoIcon";
import TurnoRealizadoIcon from "../../../assets/images/generico/TurnoRealizadoIcon";
import { hideModal, showModal } from "../../../context/Actions/modal/modal";
import { showSegundoModal } from "../../../context/Actions/segundoModal/segundoModal";
import { wsGetPlanKinesio } from "../../../context/Actions/turnos/turnosPaciente";
import { PortalContext } from "../../../context/Provider";
import modal from "../../../context/reducers/modal";
import { amOrPm } from "../../../../global/utils/amOrPm";
import { getDiaStrTurno } from "../../../../global/utils/diasTurno";
import HeaderModal from "../../Genericos/headerModal/headerModal";
import PlanTurnosKinesio from "../PlanTurnosKinesio/PlanTurnosKinesio";
import "./PlanKinesio.css";
const PlanKinesio = ({
  titulo,
  dissmiss,
  especialidad,
  fecha,
  hora,
  idTurnoSesion,
  idPacienteFamiliar
}) => {
  const {
    motivoCancelacionState,
    turnosPacienteState,
    turnosPacienteDispatch,
    segundoModalDispatch,
  } = useContext(PortalContext);

  const cancelarTodo = () => {
    showSegundoModal(
      "Turnos/MensajeCancelarTurno/MensajeCancelarTurno",
      {
        titulo: "Cancelar turno",
        texto: `Desea cancelar su turno de ${especialidad} del ${getDiaStrTurno(
          fecha
        )} ${getDiaStrTurno(fecha, true)} a las ${hora} ${amOrPm(hora)} ?`,
        items: motivoCancelacionState.motivoCancelacion.turnos,
        idTurnoSesion: idTurnoSesion,
        flgSesion: true,
        dissmiss: dissmiss,
        idPacienteFamiliar
      },
      {},
      "centro"
    )(segundoModalDispatch);
  };

  return (
    <React.Fragment>
      {!turnosPacienteState.turnosPaciente.loading && (
        <>
          <HeaderModal titulo={titulo} dissmiss={dissmiss} />
          <div className="ptur-planKinesio-body bgc-white">
            <div className="ptur-planKinesio-texto">
              <span className="c-latex10 rb18l">
                Plan de {turnosPacienteState?.turnosPaciente?.planKinesio?.length} turnos de kinesiología
              </span>
              <div className="ptur-planKinesio-acciones">
                <div className="ptur-planKinesio-acciones-caja1">
                  <div className="ptur-planKinesio-acciones-iconoTexto">
                    <TurnoRealizadoIcon
                      color="#ECECEC"
                      circulo="#d4d4d4"
                      tilde="#d4d4d4"
                      width="27"
                      height="27"
                    />
                    <span className="rb14m">Próximo turno</span>
                  </div>
                  <div className="ptur-planKinesio-acciones-iconoTexto">
                    <TurnoRealizadoIcon
                      color="#3D994A"
                      circulo="#296632"
                      tilde="#fff"
                      width="27"
                      height="27"
                    />
                    <span className="rb14m">Turno realizado</span>
                  </div>
                </div>
                <div className="ptur-planKinesio-acciones-caja2">
                  <div className="ptur-planKinesio-acciones-iconoTexto">
                    <TurnoCanceladoIcon color="#ECECEC" />
                    <span className="rb14m">Turno cancelado</span>
                  </div>
                  <div className="ptur-planKinesio-acciones-iconoTexto">
                    <TurnoNoAsistidoIcon color="#C10C00" />
                    <span className="rb14m">Turno no asistido</span>
                  </div>
                </div>
              </div>
              <div className="ptur-planKinesio-greyLine"></div>
            </div>
            <div className="ptur-planKinesio-planTurnos">
              {Array.isArray(turnosPacienteState.turnosPaciente.planKinesio) &&
                turnosPacienteState.turnosPaciente.planKinesio.map(
                  (item, index) => {
                    return (
                      <React.Fragment key={index}>
                        <PlanTurnosKinesio
                          idturno={item.idturno}
                          medico={item.medico}
                          hora={item.hora}
                          fecha={item.fecha}
                          estadoTurno={item.estadoTurno}
                          centro={item.centro}
                          ubicacion={item.ubicacion}
                          coordenadaGps={item.coordenadaGps}
                          especialidad={item.especialidad}
                          idTurnoSesion={item.idTurnoSesion}
                          esUltimo= {!turnosPacienteState.turnosPaciente.planKinesio[index + 1]? true: false}
                          idPacienteFamiliar={idPacienteFamiliar}
                        />
                      </React.Fragment>
                    );
                  }
                )}
            </div>
            <div className="ptur-planTurnosKinesio-btnCancelarPlanContainer">
              <button
                className="ptur-planTurnosKinesio-btnCancelarPlan rb16m c-white"
                onClick={cancelarTodo}
              >
                Cancelar todas las sesiones
              </button>
            </div>
            <div className="ptur-planTurnosKinesio-btnCerrarContainer">
              <button
                className="ptur-planTurnosKinesio-btnCerrar rb16m c-latex30"
                onClick={dissmiss}
              >
                Cerrar y volver
              </button>
            </div>
          </div>
        </>
      )}
    </React.Fragment>
  );
};

export default PlanKinesio;
